import { createSelector } from 'reselect';
import Scopes from '../constants/Scopes';
import { getIsUngatedForDevelopersUnifiedAppsPrivateBeta } from './GateSelectors';
export const getScopes = state => state.auth.user.scopes;

// We want to block installs into portals that have ONLY the developer-tools parcel
// "full-crm-access" is a scope that is in the hubspot-free parcel and not the developer-tools parcel. So if it exists, then the portal has more than just developer-tools
// Enhanced: If ungated for Developers:UnifiedApps:PrivateBeta, always treat as full portal (not developer-only)
export const getHasOnlyDevelopersParcel = createSelector([getScopes, getIsUngatedForDevelopersUnifiedAppsPrivateBeta], (scopes, isUngatedForDevelopersUnifiedAppsPrivateBeta) => {
  // If ungated for Developers:UnifiedApps:PrivateBeta, always treat as full portal (not developer-only)
  if (isUngatedForDevelopersUnifiedAppsPrivateBeta) {
    return false;
  }

  // Otherwise, use existing scope-based logic
  return scopes.includes(Scopes.DEVELOPER_PORTAL_ACCESS) && !scopes.includes(Scopes.FULL_CRM_ACCESS);
});
export const getHasIntegrationsManagementWrite = createSelector([getScopes], scopes => scopes.includes(Scopes.INTEGRATIONS_MANAGEMENT_WRITE));